import { render, staticRenderFns } from "./assetsType.vue?vue&type=template&id=7b3c705e"
import script from "./assetsType.vue?vue&type=script&lang=js"
export * from "./assetsType.vue?vue&type=script&lang=js"
import style0 from "./assetsType.vue?vue&type=style&index=0&id=7b3c705e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports